import { plainToClass } from "class-transformer";
import { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for reversing a route. Self-inverse: undo and redo both
 * reverse the route again, restoring the original order.
 * Stores only the route key (~100 bytes).
 */
export class ReverseRouteCommand implements UndoCommand {
  readonly type = 'REVERSE_ROUTE';
  readonly routeKey: string;

  constructor(routeKey: string) {
    this.routeKey = routeKey;
  }

  private reverse(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    route.markers.reverse();
    route.lineStrings = route.lineStrings.map(lineString => {
      const instance = plainToClass(LineStringFeature, lineString);
      return instance.reverse();
    }).reverse();
    route.updated_at = new Date();
  }

  undo(ctx: CommandContext): void {
    this.reverse(ctx);
  }

  redo(ctx: CommandContext): void {
    this.reverse(ctx);
  }
}
